import React from 'react'

const NotFoundPage = () => {
  return (
    <div className='notfoundpage'>
      <h1>Page not found</h1>
    </div>
  )
}

export default NotFoundPage
